// extracted by mini-css-extract-plugin
export default {"root":"h_kbbEyR5_"};